export default __webpack_public_path__ + "static/media/ic-close.183ca23a.svg";